var AWS = require('aws-sdk');

const config = {
    region: 'us-east-1',
    accessKeyId: 'AKIA5HXFVFNNGDIEUIPJ',
    secretAccessKey: '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',
    apiVersion: 'latest'
}

var s3 = new AWS.S3(config);

export class StoreS3 {

    static async list_files(dir = '') {

        if (dir.length && dir[dir.length - 1] !== '/') {
            dir += '/';
        }
        const params = {
            Bucket: "mikehallstudio",
            Prefix: "manifest/" + dir,
            Delimiter: "/"
        };
        return new Promise((resolve, reject) => {
            s3.listObjects(params, function (err, data) {
                if (err) {
                    console.log("List Dir Error", dir);
                    reject(err);
                } else {
                    resolve(data);
                    // console.log("List Dir Success", dir);
                }
            });
        })
    }

    static async get_file(name) {
        const params = {
            Bucket: "mikehallstudio",
            Key: "manifest/" + name
        };
        return new Promise((resolve, reject) => {
            s3.getObject(params, (err, data) => {
                if (err) {
                    console.log("Download file Error", name);
                    reject(err);
                } else {
                    resolve(data);
                    // console.log("Download Success", name);
                }
            })
        })
    }

    static async get_json_file(file_path) {
        const div_item = await StoreS3.get_file(file_path);
        return JSON.parse(div_item.Body);
    }

    static async get_file_tree(root) {
        const all_files = await StoreS3.list_files(root);
        const file_set = {};
        for (let index = 0; index < all_files.Contents.length; index++) {
            const file = all_files.Contents[index];
            const file_path = file.Key.slice(9);
            const folder_path = file_path.slice(0, file_path.length - 5) + "/";
            if (file_path.slice(file_path.length - 5) === '.json') {
                let file_item = await StoreS3.get_json_file(file_path);
                for (let jndex = 0; jndex < all_files.CommonPrefixes.length; jndex++) {
                    const compare_prefix = all_files.CommonPrefixes[jndex].Prefix.slice(9);
                    if (compare_prefix === folder_path) {
                        file_item.items = await StoreS3.get_file_tree(compare_prefix)
                    }
                }
                delete file_item["created"]
                delete file_item["updated"]
                delete file_item["path"]
                const title = file_item["title"];
                file_set[title] = file_item;
            }
        }
        return file_set;
    }

    static async put_file(name, data) {
        const params = {
            Bucket: "mikehallstudio",
            Key: "manifest/" + name,
            Body: data,
            ACL: "public-read"
        };
        s3.upload(params, (err, data) => {
            if (err) {
                console.log("Upload file Error", err);
            }
            if (data) {
                // console.log("Upload file Success", name);
            }
        });
    }

    static async delete_file(name) {
        const params = {
            Bucket: "mikehallstudio",
            Key: "manifest/" + name
        };
        s3.deleteObject(params, (err, data) => {
            if (err) {
                console.log("Delete file Error", err);
            }
            if (data) {
                console.log("Delete file Success", name);
            }
        });
    }

}

export default StoreS3;